import {
  INFECTION_AND_GERMS_REQUIRES_CLOSTRIDIEN,
  INFECTION_AND_GERMS_REQUIRES_FOUR_MRGN,
  INFECTION_AND_GERMS_REQUIRES_ISOLATION,
  INFECTION_AND_GERMS_REQUIRES_MRSA,
  INFECTION_AND_GERMS_REQUIRES_THREE_MRGN,
  INFECTION_AND_GERMS_REQUIRES_VRE,
  NO_CAPACITY_FOR_CARELEVEL,
  NO_CAPACITY_FOR_GENDER,
  NO_CAPACITY_FOR_INFECTION,
  NO_CAPACITY_FOR_ROOM,
  NO_CAPACITY_FOR_SERVICE,
  NO_CAPACITY_FOR_SOLUTION,
  NO_CAPACITY_FOR_SPECIALIZATION,
  ROOM_TYPES,
  SOLUTION_REHAB_FULL_HOSPITALIZATION,
  SOLUTION_SHORT_TERM_STATIC_CARE,
  SOLUTION_STATIC_CARE,
} from "core/consts";
import { matchesWhitelistScopes } from "core/model/auctions";
import { AuctionRequest, Careseeker, Solutions } from "core/types";
import { ageServices } from "dsl/ecosystems/CareproviderSettingsServices/ServicesCheckboxGroup";
import { carelevelWhitelist } from "dsl/organisms/PatientProfileDetailsShared/modelDefinition";

// TODO: to remove when infections are ontologies
export function convertInfectionsToOntologiesIds(
  infectionKeys: Array<string>,
): Array<number> {
  return infectionKeys.map((infectionKey) => {
    switch (infectionKey) {
      case "requires_isolation":
        return INFECTION_AND_GERMS_REQUIRES_ISOLATION;
      case "mrsa":
        return INFECTION_AND_GERMS_REQUIRES_MRSA;
      case "three_mrgn":
        return INFECTION_AND_GERMS_REQUIRES_THREE_MRGN;
      case "four_mrgn":
        return INFECTION_AND_GERMS_REQUIRES_FOUR_MRGN;
      case "clostridien":
        return INFECTION_AND_GERMS_REQUIRES_CLOSTRIDIEN;
      case "vre":
        return INFECTION_AND_GERMS_REQUIRES_VRE;
      default:
        return -1;
    }
  });
}

export const REASONS_VALUES = [
  {
    predicate: ({ solutions }: AuctionRequest) => !!solutions?.length,
    reason: NO_CAPACITY_FOR_SOLUTION,
    values: ({ solutions }: AuctionRequest) =>
      solutions?.length ? solutions : null,
  },
  {
    predicate: ({ auction }: AuctionRequest) => auction?.services,
    reason: NO_CAPACITY_FOR_SERVICE,
    values: ({ auction }: AuctionRequest) =>
      auction?.services?.filter((service) => !ageServices.includes(service)),
  },
  {
    predicate: ({ auction }: AuctionRequest) => {
      if (!auction?.solutions) return false;

      const solutions = auction?.solutions;
      const whiteList = [
        SOLUTION_STATIC_CARE,
        SOLUTION_SHORT_TERM_STATIC_CARE,
        SOLUTION_REHAB_FULL_HOSPITALIZATION,
      ] as Solutions;
      return (
        auction?.patient?.profile?.gender &&
        solutions.some((solution) => whiteList.includes(solution))
      );
    },
    reason: NO_CAPACITY_FOR_GENDER,
    values: ({ auction }: AuctionRequest) => [
      auction?.patient?.profile?.gender,
    ],
  },
  {
    predicate: ({ auction }: AuctionRequest, careseeker: Careseeker) =>
      matchesWhitelistScopes(carelevelWhitelist)({
        careseeker,
        formInputValue: auction,
      }),
    reason: NO_CAPACITY_FOR_CARELEVEL,
    values: ({ auction }: AuctionRequest) => {
      const carelevel =
        auction?.patient?.profile?.financing?.carelevel?.level || -1;
      return carelevel > 0 ? [carelevel] : [0];
    },
  },
  {
    predicate: ({ auction }: AuctionRequest) => {
      if (
        !auction?.solutions ||
        auction?.patient?.profile?.preferences?.room_type ===
          ROOM_TYPES.NO_PREFERENCE
      )
        return false;

      return auction?.patient?.profile?.preferences?.room_type;
    },
    reason: NO_CAPACITY_FOR_ROOM,
    values: ({ auction }: AuctionRequest) => [
      auction?.patient?.profile?.preferences?.room_type,
    ],
  },
  {
    predicate: ({ auction }: AuctionRequest) =>
      auction?.patient?.diagnosis?.infection_and_germs,
    reason: NO_CAPACITY_FOR_INFECTION,
    values: ({ auction }: AuctionRequest) => {
      const infections: { [key: string]: any } | undefined =
        auction?.patient?.diagnosis?.infection_and_germs;
      if (infections != null) {
        const infectionKeys = Object.keys(infections);
        const trueInfections = infectionKeys.filter(
          (key) => infections[key] === true,
        );
        const infectionsIds = convertInfectionsToOntologiesIds(trueInfections);
        return infectionsIds;
      }
      return [];
    },
  },
  {
    predicate: ({ auction }: AuctionRequest) =>
      auction?.specializations != null,
    reason: NO_CAPACITY_FOR_SPECIALIZATION,
    values: ({ auction }: AuctionRequest) =>
      auction?.specializations != null ? auction.specializations : null,
  },
];
